export default __webpack_public_path__ + "static/media/SudOuest.62b748ff.jpg";